import React from 'react';
import '../css/Grid.css';

import Images from '../composant/Images';
import Text from '../composant/Text';

const Grid = ({data}) => {
    return (
        <div className='Grid'>
            <div className='left'>
                <Images data={data.Left.img} style={{
                    display: 'inline-block'
                }}></Images>
                <Text data={data.Left.content} className={'box'}></Text>
            </div>
            <div className='right'>
                <Images data={data.Right.img}></Images>
                <Text data={data.Right.content} className={'box'}></Text>
            </div>
        </div>
    )
}

export default Grid;